var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppeldoffre(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_2213)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_585_2213",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H18V18H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_585_2213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6489 14.6787C13.8126 14.6787 13.1348 14.0008 13.1348 13.1646V12.6588C13.1348 11.8225 13.8126 11.1447 14.6489 11.1447C15.4851 11.1447 16.163 11.8225 16.163 12.6588V13.1646C16.163 14.0008 15.4851 14.6787 14.6489 14.6787Z",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8162 14.4296L13.2387 14.6147C12.396 14.8846 11.8242 15.6681 11.8242 16.5529V17.4727H17.4726V16.5529C17.4726 15.6681 16.9009 14.8846 16.0582 14.6147L15.4808 14.4297",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00047 14.6787C8.16425 14.6787 7.48633 14.0008 7.48633 13.1646V12.6588C7.48633 11.8225 8.16425 11.1447 9.00047 11.1447C9.8367 11.1447 10.5146 11.8225 10.5146 12.6588V13.1646C10.5146 14.0008 9.8367 14.6787 9.00047 14.6787Z",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16773 14.4296L7.59022 14.6147C6.74753 14.8846 6.17578 15.6681 6.17578 16.5529V17.4727H11.8242V16.5529C11.8242 15.6681 11.2525 14.8846 10.4098 14.6147L9.83235 14.4297",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35204 14.6787C2.51581 14.6787 1.83789 14.0008 1.83789 13.1646V12.6588C1.83789 11.8225 2.51581 11.1447 3.35204 11.1447C4.18826 11.1447 4.86614 11.8225 4.86614 12.6588V13.1646C4.86614 14.0008 4.18826 14.6787 3.35204 14.6787Z",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5193 14.4296L1.94179 14.6147C1.09909 14.8846 0.527344 15.6681 0.527344 16.5529V17.4727H6.17576V16.5529C6.17576 15.6681 5.60405 14.8846 4.76132 14.6147L4.18391 14.4297",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6894 0.526911H2.31054C1.32571 0.526911 0.527344 1.32527 0.527344 2.31014V7.17868C0.527344 8.16355 1.32571 8.96191 2.31054 8.96191H2.7745V8.66667C2.7745 8.03077 3.28999 7.51527 3.92593 7.51527H7.33286C7.49028 8.33912 8.21419 8.96191 9.08392 8.96191H9.54787V8.66667C9.54787 8.03077 10.0634 7.51527 10.6993 7.51527H14.0741C14.71 7.51527 15.2255 8.03077 15.2255 8.66667V8.96191H15.6894C16.6743 8.96191 17.4727 8.16355 17.4727 7.17868V2.31014C17.4727 1.32527 16.6743 0.526911 15.6894 0.526911Z",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3952 5.17383H3.60547",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54688 2.85059H12.4528",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_2213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppeldoffre);
export default __webpack_public_path__ + "static/media/appeldoffre.44c04201966da8f9c75cc5853dbbbd2b.svg";
export { ForwardRef as ReactComponent };